import Vue from "vue";
import utils from "utils";
const filterList = {
  formatTime(val, arg) {
    if (!val) return "";
    let tem1 = val * 1000;
    let date = new Date(arg * 1000);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    if (tem1 > date.getTime()) {
      return `今天 ${utils.dateFormat("HH:MM", new Date(tem1))}`;
    } else if (
      tem1 < date.getTime() &&
      tem1 > date.getTime() - 1000 * 60 * 60 * 24
    ) {
      return `昨天 ${utils.dateFormat("HH:MM", new Date(tem1))}`;
    } else {
      return utils.dateFormat("mm-dd HH:MM", new Date(tem1));
    }
  },
  //名字13位的过滤器
  realSubstring(value, n = 13,str) {
    if (!value) return "";
    let v = value.toString();
    if (utils.realLength(v) <= n) {
      return v;
    }
    var m = Math.floor(n / 2);
    for (var i = m; i < v.length; i++) {
      if (utils.realLength(v.substr(0, i)) >= n) {
        if(str){
          return v.substr(0, i)+str;
        }
        return v.substr(0, i);
      }
    }
    return v;
  },
  time(times) {
    let result = "00:00:00";
    if (times > 0) {
      let hour, minute, second;
      hour = Math.floor(times / 3600) + "";
      hour = hour.padStart(2, 0);
      minute = Math.floor((times - 3600 * hour) / 60) + "";
      minute = minute.padStart(2, 0);
      second = Math.floor(times % 60) + "";
      second = second.padStart(2, 0);
      result = hour + ":" + minute + ":" + second;
    }
    return result;
  },
};
export default function registerFilter() {
  for (let key in filterList) {
    Vue.filter(key, filterList[key]);
  }
}



// WEBPACK FOOTER //
// ./src/js/filter.js